import { FormikField } from '@ahmdigital/ui';

import styles from '../styles.module.sass';

type AgeFieldProps = {
  age?: number | null;
  labelText: string;
  name: string;
};

const AgeField = ({ age, labelText, name }: AgeFieldProps) => (
  <div className={styles.wrapper}>
    <div className={styles.labelWrapper}>
      <label id={`label-for-${name}`} htmlFor={name}>
        {`${labelText}*`}
      </label>
    </div>
    <FormikField
      input={{ inputMode: 'numeric', pattern: '[0-9]*' }}
      className={styles.ageInput}
      name={name}
      placeholder="e.g. 30"
      type="text"
      maxLength="3"
      value={age ?? undefined}
    />
  </div>
);

export default AgeField;
